import scrollLock from './functions/_scrollLock.js' // スクロールロック

const modals = document.getElementsByClassName('js-modal') // モーダル本体
const modalYoutube = document.getElementsByClassName('js-modal-youtube') // モーダル内YouTube
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    scrollLock('body', '.js-modal')

    // YouTubeのsrcを読み込む
    const youtube = document.querySelector('.js-modal--' + target + ' .js-modal-youtube')
    if (youtube) {
      youtube.setAttribute('src', youtube.dataset.src)
    }
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    scrollLock('body', '.js-modal')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }

  // YouTubeのsrcを消して動画を止める
  for (let index = 0; index < modalYoutube.length; index++) {
    modalYoutube[index].setAttribute('src', '')
  }
}
